'use client';

import { Button } from '@wk/wk-uni-lib';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { getSubscriptionEsStatus } from '@/api/order';
import { useLanguage } from '@/hooks/use-language';
import { useTraceCommonParams } from '@/hooks/use-trace-common-params';

import { navigateToOldProject } from '../../../../utils/url';

export default function SubscribeButton() {
  const { currentLanguage } = useLanguage();
  const [showSubscribeButton, setShowSubscribeButton] =
    useState<boolean>(false);
  const { traceWithCommonParams } = useTraceCommonParams();
  const pathname = usePathname().replace('/zh', '');

  const fetchSubscriptionData = async () => {
    const res = await getSubscriptionEsStatus();
    const data = res?.content as any;
    setShowSubscribeButton(data?.display);
  };

  useEffect(() => {
    fetchSubscriptionData();
  }, []);

  if (!showSubscribeButton) {
    return null;
  }

  const handleToSubscriptionDetail = () => {
    const data = {
      _event: 'U_HP_SubscribeEnterClick',
      teacherId: '',
      courseStatus: '',
      studentType: 'GS2.0',
    };
    traceWithCommonParams(data);

    let breadPath = '';
    if (pathname.startsWith('/home')) {
      breadPath = 'home';
    } else if (pathname.startsWith('/study')) {
      breadPath = 'study';
    } else if (pathname.startsWith('/account')) {
      breadPath = 'account';
    }
    navigateToOldProject(
      `/${currentLanguage}/home/subscriptionDetails?triggerEvent=U_HP_SubscribeEnterClick&isNewNav=1&breadPath=${breadPath}`,
    );
  };

  return (
    <Button onClick={handleToSubscriptionDetail}>
      {currentLanguage === 'zh' ? '订阅' : 'Subscribe'}
    </Button>
  );
}
